const geracao_de_contantes_alunos_novos = {
  path: "/geracao-de-constantes-alunos-novos",
  redirect: "/geracao-de-constantes-alunos-novos",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Constantes Alunos Novos",
  },
  children: [
    {
      path: "/geracao-de-constantes-alunos-novos",
      name: "geracao-de-constantes-alunos-novos",
      component: () =>
        import(
          "@/views/GerarConstantesAlunosNovos/GerarConstantesAlunosNovosHome.vue"
        ),
    },
  ],
};

export { geracao_de_contantes_alunos_novos };
